"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function range(value, options, params) {
    var isValid = true;
    var errors;
    if ((typeof value === 'string' ? value.length : value) < options.min) {
        isValid = false;
        errors = {
            constraints: {
                min: options.min.toString(),
            },
            params: [options.min.toString()],
        };
    }
    if ((typeof value === 'string' ? value.length : value) > options.max) {
        isValid = false;
        errors = {
            constraints: {
                max: options.max.toString(),
            },
            params: [options.max.toString()],
        };
    }
    return {
        isValid: isValid,
        errors: errors,
    };
}
exports.default = range;
